import { render, staticRenderFns } from "./initRoot.vue?vue&type=template&id=616c3fe9&scoped=true&"
import script from "./initRoot.vue?vue&type=script&lang=js&"
export * from "./initRoot.vue?vue&type=script&lang=js&"
import style0 from "./initRoot.vue?vue&type=style&index=0&id=616c3fe9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616c3fe9",
  null
  
)

export default component.exports